/**
 * Copyright (c) SAGE3 Development Team 2022. All Rights Reserved
 * University of Hawaii, University of Illinois Chicago, Virginia Tech
 *
 * Distributed under the terms of the SAGE3 License.  The full license is in
 * the file LICENSE, distributed as part of this software.
 */

import { useEffect, useState } from 'react';

/**
 * Get a piece of JSON data from the server
 * From react docs
 * @param url the url to send the request to
 * @returns
 */
export function useData(url: string) {
  const [result, setResult] = useState<any>();
  useEffect(() => {
    let ignore = false;
    fetch(url)
      .then((response) => response.json())
      .then((json) => {
        if (!ignore) {
          setResult(json);
        }
      })
      .catch(() => {
        window.location.replace('/');
      });
    return () => {
      ignore = true;
    };
  }, [url]);
  return result;
}
